(function () {
  var minDisplayTime = 2600; // Increased to 3200ms so the preloader stays on screen longer for the slow animation
  var startTime = Date.now();

  document.addEventListener('DOMContentLoaded', function () {
    var mark = document.getElementById('aroma-mark-wrap');
    var left = document.getElementById('aroma-frame-left');
    var right = document.getElementById('aroma-frame-right');
    var bottom = document.getElementById('aroma-frame-bottom');
    var top = document.getElementById('aroma-frame-top');
    var text = document.getElementById('aroma-preloader-text');
    if (!mark || !left || !right || !bottom || !top) return;

    // 0. Reveal the inner logo A shape
    requestAnimationFrame(function () {
      mark.classList.add('reveal');
    });

    // 1. Draw BOTTOM line (starts at 300ms, takes 400ms)
    setTimeout(function () {
      bottom.classList.add('reveal');
    }, 300);

    // 2. Draw RIGHT line (starts exactly when Bottom finishes at 700ms)
    setTimeout(function () {
      right.classList.add('reveal');
    }, 700);

    // 3. Draw TOP line (starts exactly when Right finishes at 1100ms)
    setTimeout(function () {
      top.classList.add('reveal');
    }, 1100);

    // 4. Draw LEFT line (starts exactly when Top finishes at 1500ms)
    setTimeout(function () {
      left.classList.add('reveal');
    }, 1500);

    // 5. Fade in the text at the end
    setTimeout(function () {
      if (text) text.classList.add('show');
    }, 2000); // Waits for all lines to finish
  });

  window.addEventListener('load', function () {
    var el = document.getElementById('aroma-preloader');
    if (!el) return;
    var elapsed = Date.now() - startTime;
    var remaining = Math.max(minDisplayTime - elapsed, 0);
    setTimeout(function () {
      el.classList.add('hidden');
      setTimeout(function () { el.style.display = 'none'; }, 400);
    }, remaining);
  });
})();